import { Moon, Sun, Monitor } from "lucide-react";
import { useEffect, useState } from "react";
import { getTheme, setTheme, type Theme } from "../lib/theme";

export function ThemeToggle() {
  const [theme, setLocalTheme] = useState<Theme>(getTheme());

  useEffect(() => {
    const handler = () => setLocalTheme(getTheme());
    window.addEventListener("praesto:theme-change", handler);
    return () => window.removeEventListener("praesto:theme-change", handler);
  }, []);

  function cycle() {
    const next: Theme = theme === "light" ? "dark" : theme === "dark" ? "system" : "light";
    setTheme(next);
    setLocalTheme(next);
  }

  const Icon = theme === "dark" ? Moon : theme === "system" ? Monitor : Sun;
  const label =
    theme === "dark" ? "Tema scuro" : theme === "system" ? "Tema sistema" : "Tema chiaro";

  return (
    <button
      onClick={cycle}
      title={label}
      aria-label={label}
      className="flex h-9 w-9 items-center justify-center rounded-md text-fg-muted transition-colors duration-fast hover:bg-hover hover:text-fg-default"
    >
      <Icon size={18} />
    </button>
  );
}
